// extracted by mini-css-extract-plugin
export default {"dateTable":"Schedules_dateTable__3znaF","scTable":"Schedules_scTable__BUi+L","w20":"Schedules_w20__DauHG","w80":"Schedules_w80__G4B6d"};